module.exports = __webpack_public_path__ + "static/media/loading-preview.05889591.gif";